import { createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const toolboxInitialState = {
  isReactQueryDevToolsEnabled: false,
  isKambiLoggingEnabled: false,
}

const toolboxSlice = createSlice({
  name: 'toolbox',
  initialState: toolboxInitialState,
  reducers: {
    toggleReactQueryDevTools(state) {
      state.isReactQueryDevToolsEnabled = !state.isReactQueryDevToolsEnabled
    },

    toggleKambiLogging(state) {
      state.isKambiLoggingEnabled = !state.isKambiLoggingEnabled
    },
  },
})

export const { toggleReactQueryDevTools, toggleKambiLogging } = toolboxSlice.actions

export default persistReducer({ key: 'toolbox', storage }, toolboxSlice.reducer)
